import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get ({ commit, dispatch }, payload) {
    let url = 'api/reports/by-category/' + payload.event.items.url
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getDownload ({ commit, dispatch }, payload) {
    let url = 'api/reports/by-category/' + payload.event.items.url
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      responseType: 'blob'
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options)
      .then(
        response => {
          commit('onGetDownload', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getLogged ({commit, dispatch}, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the applications endpoint
  onGet (state, payload) {
    let concepts = payload.response.data.data
    payload.event.context.concepts = concepts
    let expensesItems = payload.response.data.data.expensesItemsByMonth
    if (expensesItems !== null) {
      let months = Object.getOwnPropertyNames(expensesItems)
      months.pop()
      let newItems = []
      for (let i = 0; i < months.length; i++) {
        const item = months[i]
        if (item !== '0') {
          let temp = {
            month: parseInt(item),
            items: expensesItems[item]
          }
          newItems.push(temp)
        }
      }
      expensesItems = newItems
    }
    payload.event.context.expensesItems = expensesItems
    payload.event.context.itemDialog = true
    payload.event.context.loading = false
    payload.event.context.dialog = false
    payload.event.context.loadingItems = false
  },
  onGetDownload (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, `ExpensesCategory ${date}.xlsx`)
    payload.event.context.loadingDownload = false
  },
  // Shows a error message
  onError (state, payload) {
     const error = payload.error

    if (error.message === 'Network Error' && !error.response) { 
      payload.event.context.loadingItems = false
      payload.event.context.showNotification(payload.event.context.$t('general.errorChargeDataByRangeDate'), 'error', -1)
      return 
    }
    
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    // payload.event.context.refresh()
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
    payload.event.context.getAreasCompany()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reportstype.js